var objectToString = Object.prototype.toString

module.exports = objectToString



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticObjectToString.js
// module id = 452
// module chunks = 75